import { API } from './instances'
import { mockPrescriptions } from '../constants/mockPrescriptions'

export const getPrescriptions = async params => {
	const url = '/Prescripciones/ObtenerPrescripciones'
	return await API.post(url, params, { skipErrorMessage: true })
}
